import { render, staticRenderFns } from "./c_player_registInfo_details.vue?vue&type=template&id=dba50dbc&scoped=true&"
import script from "./c_player_registInfo_details.vue?vue&type=script&lang=js&"
export * from "./c_player_registInfo_details.vue?vue&type=script&lang=js&"
import style0 from "./c_player_registInfo_details.vue?vue&type=style&index=0&id=dba50dbc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba50dbc",
  null
  
)

export default component.exports